import { Dispatch, SetStateAction } from "react";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import useToast from "../useToast";

import { closeModal } from "../../store/slices/modal";
import cookiesHelper from "../../helpers/cookies";
import api from "../apiClient";

export interface IPayload {
    payload: number[];
    setIsProcessing: Dispatch<SetStateAction<boolean>>;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useInviteUsers = () => {
    const { addToast } = useToast();
    const dispatch = useDispatch();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`

        const res = await api.post(`users/invite`, data.payload);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response) {
                addToast({
                    type: 'success',
                    title: `Invitation${variables.payload.length > 1 ? 's' : ''} sent successfully.`,
                });

                dispatch(closeModal('MESSAGE_MODAL'));
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useInviteUsers;